import React from "react";

export default function TabContainer({ children }) {
  return <div style={{ paddingBottom: 50 }}>{children}</div>;
}
